import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../common/integrations'
import { CrossClientQueryDataSource } from '../../../../models/CrossClient'

export const getCrossClientResultSourceLabel = (source: CrossClientQueryDataSource): string => {
  if (source.type === 'clientProfile') {
    return 'Client Profiles'
  }

  if (source.type === 'integration') {
    return getIntegrationDisplayName(source.integrationType as IntegrationServiceId)
  }

  return 'Unknown'
}
